// Modules
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'sbi-cot-back-default-dialog',
    templateUrl: './default-dialog.component.html',
    styleUrls: ['./default-dialog.component.scss'],
    standalone: false
})
export class DefaultDialogComponent {
  // Constructor
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
